"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import * as React from "react";

import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";

export function NavigationMenuApp() {
  return (
    <NavigationMenu viewport={false} className="z-50 hidden md:block">
      <NavigationMenuList className="flex gap-4">
        <Item title="Início" href="/" />
        <Item title="Serviços" href="/#servicos" />
        <Item title="Sobre" href="/#sobre" />{" "}
        <Item title="Depoimentos" href="/#depoimentos" />
        <Item title="Blog" href="/blog" />
        <Item title="Contato" href="/#contato" />
      </NavigationMenuList>
    </NavigationMenu>
  );
}

function Item({
  title,
  href,
  children,
  ...props
}: React.ComponentPropsWithoutRef<"li"> & { href: string }) {
  const router = useRouter();
  const pathname = usePathname();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // se o link contém hash (#), queremos rolar suavemente
    if (href.startsWith("/#")) {
      e.preventDefault();

      const targetId = href.split("#")[1];
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // scroll suave até a seção
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // caso o elemento ainda não exista, navegar primeiro e depois rolar
        router.push("/#" + targetId);
      }
    } else {
      router.push(href);
    }
  };

  return (
    <li {...props}>
      <NavigationMenuLink
        asChild
        className={`space-x-8 rounded-none py-1 text-base tracking-wide transition-all duration-200 ${
          pathname === href ? "text-black" : ""
        }`}
      >
        <Link href={href} onClick={handleClick}>
          {title}
          {children}
        </Link>
      </NavigationMenuLink>
    </li>
  );
}
